import { getAction } from '../api/manage'
import Vue from 'vue'
export const LanguagePackage = {
  data() {
    return {
      LangPackage: {
        zh: {},
        en: {},
        ja: {},
      },
    }
  },
  created() {
    if(Vue.ls.get("translatePack")){
      this.LangPackage = Vue.ls.get("translatePack");
    }
    getAction('/translate/pmsTranslateContent/getTranslatePack').then((rs) => {
      if (rs.success) {
        this.LangPackage = rs.result
        Vue.ls.set('translatePack', rs.result)
      }
    })

    // console.debug(this.LangPackage);

    this.initlanguage()
  },
  methods: {
    initlanguage() {
      //初始化列表
      if (this.translateCol) {
        for (let i = 0; i < this.translateCol.length; i++) {
          //取出表头数据
          let colName = this.translateCol[i]
          let colData
          eval(`
            colData = this.${colName};
          `)
          this.colTs(colData)
        }
      }

      //校验提示翻译
      this.validatorTranslate()

      if (this.translateProperty) {
        for (let i = 0; i < this.translateProperty.length; i++) {
          //取出数据
          let left = this.translateProperty[i].split(',')[0]
          let right = this.translateProperty[i].split(',')[1]
          let item
          eval(`
            item = this.${left};
          `)
          //初始化原始文本
          if (!item.sourceTitle) {
            item.sourceTitle = item[right]
          }
          this.propTs(item, right)
        }
      }

      //左侧菜单翻译
      if (this.menus && this.menus.length > 0) {
        for (let i = 0; i < this.menus.length; i++) {
          this.menuTs(this.menus[i])
        }
      }
    },
    validatorTranslate() {
      let that = this
      if (this.validatorRules) {
        console.debug('开始翻译校验提示')
        for (let key in this.validatorRules) {
          let rules = this.validatorRules[key].rules
          if (rules && rules.length > 0) {
            rules.forEach((item) => {
              if (item.message) {
                if (!item.sourceTitle) {
                  item.sourceTitle = item.message
                }
                that.propTs(item, 'message')
              }
            })
          }
        }
      }
    },
    translate(text) {
      if (!this.LangPackage[this.$store.state.currentLanguage][text]) {
        let that = this
        getAction('/aws/translate', { text: text }).then((rs) => {
          if (rs.result) {
            if (rs.result.lang == 'zh-TW') {
              rs.result.lang = 'zh'
            }
            that.$set(that.LangPackage[rs.result.lang], text, rs.result.text)
          }
        })
        return text
      } else {
        return this.LangPackage[this.$store.state.currentLanguage][text]
      }
    },
    ts(text) {
      let that = this
      //如果没有静态翻译文本则走缓存或翻译接口
      if (!this.LangPackage[this.$store.state.currentLanguage][text]) {
        getAction('/aws/translate', { text: text }).then((rs) => {
          if (rs.result) {
            if (rs.result.lang == 'zh-TW') {
              rs.result.lang = 'zh'
            }
            // Vue.ls.set(text + rs.result.lang,rs.result.text);
            return that.$set(that.LangPackage[rs.result.lang], text, rs.result.text)
          }
        })
      }
      return this.LangPackage[this.$store.state.currentLanguage]
    },
    /**
     * 翻译属性
     * @param item 属性对象
     * @param name 要翻译的属性
     */
    propTs(item, name) {
      console.debug('开始翻译属性:' + item)
      let text = item.sourceTitle
      if (!this.LangPackage[this.$store.state.currentLanguage][text]) {
        getAction('/aws/translate', { text: text }).then((rs) => {
          if (rs.result) {
            // Vue.ls.set(text + rs.result.lang,rs.result.text);
            item[name] = rs.result.text
          }
        })
      } else {
        item[name] = this.LangPackage[this.$store.state.currentLanguage][text]
      }
    },
    colTs(colData) {
      for (let j = 0; j < colData.length; j++) {
        let text
        if (!colData[j].sourceTitle) {
          colData[j].sourceTitle = colData[j].title
        }
        text = colData[j].sourceTitle
        if (!this.LangPackage[this.$store.state.currentLanguage][text]) {
          getAction('/aws/translate', { text: text }).then((rs) => {
            if (rs.result) {
              // Vue.ls.set(text + rs.result.lang,rs.result.text);
              colData[j].title = rs.result.text
            }
          })
        } else {
          colData[j].title = this.LangPackage[this.$store.state.currentLanguage][text]
        }
      }
    },
    menuTs(item) {
      let childs = item.children
      let text
      if (!item.sourceTitle) {
        item.sourceTitle = item.meta.title
      }
      text = item.sourceTitle
      if (!this.LangPackage[this.$store.state.currentLanguage][text]) {
        getAction('/aws/translate', { text: text }).then((rs) => {
          if (rs.result) {
            // Vue.ls.set(text + this.$store.state.currentLanguage,rs.result);
            item.meta.title = rs.result
          }
        })
      } else {
        item.meta.title = this.LangPackage[this.$store.state.currentLanguage][text]
      }
      if (childs) {
        for (let i = 0; i < childs.length; i++) {
          this.menuTs(childs[i])
        }
      }
    },
  },
  watch: {
    language(val) {
      this.initlanguage()
    },
    menus() {
      for (let i = 0; i < this.menus.length; i++) {
        this.menuTs(this.menus[i])
      }
    },
  },
  computed: {
    _lg() {
      return this.LangPackage[this.$store.state.currentLanguage]
    },
    language() {
      return this.$store.state.currentLanguage
    },
  },
}
